export { default as Gestores } from "./Gestores"
export { default as GestoresEditForm } from "./GestoresEditForm"
export { default as GestoresCreateForm } from "./GestoresCreateForm"
export { default as TableGestores } from "./TableGestores"
export { default as TableGestoresTrash } from "./TableGestoresTrash"
export { default as GestoresTrash } from "./GestoresTrash"



// WEBPACK FOOTER //
// ./src/views/gestores/index.js